import { useSelector } from 'react-redux';
import {Access} from "../Constants/userRoles";

const useUserAccess = () => {
    const user = useSelector((state) => state.CommonReducer.user);
    const hasAccess = (role, access = Access.Admin)=> {
        return user && user.userRoles.some(r => r.roleId === role && r.access >= access);
    };

    const hasAdminAccess = (role)=> {
        return hasAccess(role, Access.Admin);
    };
    
    const hasReadWriteAccess = (role) => {
        return hasAccess(role, Access.ReadWrite)
    }
    
    const isAuthenticated = () => {
        return !!user;
    }


    return {
        hasAccess,
        hasAdminAccess,
        hasReadWriteAccess,
        isAuthenticated
    };
};

export default useUserAccess;
